import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service';
import {
  GetTransactionConsumerPlansParams,
  GetTransactionConsumerPlansResponse,
} from '../../';

@Injectable({
  providedIn: 'root',
})
export class TransactionsService {
  constructor(private readonly apiService: ApiService) {}

  getTransactionConsumerPlans(
    getTransactionConsumerPlansParams: GetTransactionConsumerPlansParams
  ): Observable<GetTransactionConsumerPlansResponse> {
    let params = new HttpParams();

    Object.keys(getTransactionConsumerPlansParams).forEach((param) => {
      if (param !== 'consumerIdentityUuid') {
        params = params.append(param, getTransactionConsumerPlansParams[param]);
      }
    });

    return this.apiService.get(
      `/v1/transactions/consumers/consumer/${getTransactionConsumerPlansParams.consumerIdentityUuid}/plans`,
      params
    );
  }
}
